import { domainLocales } from '@hhgtech/hhg-components/constants'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'

import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { DEFAULT_IMG } from 'interfaces/constants'
import { Category } from 'interfaces/types'

import useStyles from './index.styles'

type Props = {
  data: Category
} & BoxProps
export const Item = ({ data, styles, classNames }: Props) => {
  const { locale } = useRouterExtend()
  const isMobile = useIsMobile()
  const { classes } = useStyles(undefined, {
    name: 'ArticleCardList__Categories-Item',
    styles,
    classNames,
  })
  return (
    <Box
      component="a"
      target="_blank"
      href={data.permalink}
      className={classes.item}
      data-event-category="Service Connection"
      data-event-action="Related Category Click"
      data-event-label={`https://${domainLocales[locale]}${data.permalink}`}
    >
      <Box className={classes.inner}>
        <Box className={classes.thumb}>
          <img
            loading="lazy"
            src={data.featureImage || DEFAULT_IMG}
            alt={data.name}
            className={classes.thumbImg}
          />
        </Box>
        <Text size={isMobile ? 's3' : 's4'} className={classes.itemHeading}>
          {data.name}
        </Text>
      </Box>
    </Box>
  )
}
